import React, { useState, useEffect, useMemo } from 'react';
import Swal from 'sweetalert2';
import './SorteoExpress.css';
import RuletaNumero from './ruletacandado';

const SorteoExpress = ({ dataInfo }) => {
  // console.log(dataInfo);
  const [numeros, setNumeros] = useState(dataInfo.data.sorteo.arryPuestos);
  const [sorteo, setSorteo] = useState({})
//   const [premioBase, setPremioBase] = useState(dataInfo.data.sorteo.premioBase);
  const [totalPremio, setTotalPremio] = useState(dataInfo.data.sorteo.premioBase);
  const [seleccionados, setSeleccionados] = useState([]);
  const [cantidadAleatoria, setCantidadAleatoria] = useState(1); // Estado para la cantidad aleatoria
  const [timecero, setTimecero] = useState(dataInfo.data.sorteo.listo)
  const [start, setStart] = useState(false)
  const [finish, setFinish] = useState(false)
  const [winningNumbers, setWinningNumbers] = useState([ 0, 0 ]);
  const [userGanador, setUserGanador] = useState(null) 
  const [reset, setReset] = useState(false) // Ejemplo de números ganadores
  const [saldo, setSaldo] = useState(dataInfo.data.dataUser.saldo)

  console.log(timecero)
  
 

  const actualizarSeleccionados = (arryPuestos, seleccionados) => {
    const nuevosSeleccionados = seleccionados.filter((numero) => {
      const puesto = arryPuestos.find((obj) => Object.keys(obj)[0] === numero);
      return puesto && Object.values(puesto)[0] === ''; // Solo mantener si el puesto está vacío
    });
    return nuevosSeleccionados;
  };

  useEffect(() => {
    console.log('se realizo un cambio')
    const posicion = dataInfo.data.dataSorteos.findIndex(
      (obj) => obj.id === dataInfo.data.sorteo.id
    );
    setSorteo(dataInfo.data.dataSorteos[posicion])
    setNumeros(dataInfo.data.dataSorteos[posicion].arryPuestos);
    setTotalPremio(dataInfo.data.dataSorteos[posicion].premioBase)
    const nuevosSeleccionados = actualizarSeleccionados(
      dataInfo.data.dataSorteos[posicion].arryPuestos,
      seleccionados
    );
    setTimecero(dataInfo.data.dataSorteos[posicion].listo)
    setSeleccionados(nuevosSeleccionados);
    if(dataInfo.data.dataSorteos[posicion].ganador){
      function numberToArray(num) {
        return num.toString().split('').map(Number);
      }
      const digitos = numberToArray(dataInfo.data.dataSorteos[posicion].ganador);
      setWinningNumbers(digitos)
      setUserGanador(dataInfo.data.dataSorteos[posicion].userGanador)
      if(!finish){
        setStart(true)
      }
      setSaldo(dataInfo.data.dataUser.saldo)
    }
  }, [dataInfo.data.dataSorteos]);

  useEffect(()=>{
    if(finish){
      setStart(false)
      setReset(true)
      if(userGanador === dataInfo.data.dataUser.uid){
        Swal.fire({
          title: `¡Felicidades ${dataInfo.data.dataUser.nombre}, eres el afortunado GANADOR!`,
          text: `Felicidades, eres el ganador de: ${sorteo.premioBase}, con el numero ${sorteo.ganador}, tu premio sera cargado al saldo de tu cuenta, su saldo actual es ${saldo}, su nuevo saldo es de : ${dataInfo.data.dataUser.saldo.toLocaleString('es-ES')}`,
          icon: 'success',
          confirmButtonText: '¡Acepta tu premio!',
          confirmButtonColor: '#3085d6',
          background: '#f2f2f2',
          backdrop: `
              rgba(0,0,0,0.8)
              url('https://media.giphy.com/media/DKnMqdm9i980E/giphy.gif?cid=790b7611qo91ljkyfl51ulmqq6wtpffm538zqnpzrxaskpbw&ep=v1_gifs_search&rid=giphy.gif&ct=g') 
              center top
              no-repeat
          `,
        }).then((result)=>{
          if (result.isConfirmed) {
            setStart(false)
            //dataInfo.cambioBoard('index')
            // Opcional: Aquí puedes realizar otras acciones, como llamar a una API o actualizar el estado de la UI
        }
        })
      }else{
        Swal.fire({
            title: '¡Sorteo Finalizado!',
            text: `El número ganador es: ${sorteo.ganador}`,
            icon: 'success',
            confirmButtonText: '¡Felicidades al ganador!',
            confirmButtonColor: '#3085d6',
            background: '#f2f2f2',
            backdrop: `
                rgba(0,0,0,0.8)
                url('https://media.giphy.com/media/3oz8xAFtqoOUUrsh7W/giphy.gif') 
                center top
                no-repeat
            `,
            
        }).then((result) => {
            // Si el usuario hace clic en el botón de confirmación
            if (result.isConfirmed) {
              setStart(false)
                //dataInfo.cambioBoard('index')
                // Opcional: Aquí puedes realizar otras acciones, como llamar a una API o actualizar el estado de la UI
            }
        });
      }
    }
  },[finish])

  // Seleccionar números aleatorios disponibles
  const seleccionarNumerosAleatorios = (cantidad) => {
    // Filtrar los números disponibles
    const disponibles = numeros
      .filter((n) => Object.values(n)[0] === '') // Filtrar números sin comprador
      .map((n) => Object.keys(n)[0]); // Obtener solo las llaves (números)

    if (disponibles.length < cantidad) {
      Swal.fire({
        title: 'Error',
        text: 'No hay suficientes números disponibles.',
        icon: 'error',
      });
      return;
    }

    // Seleccionar aleatoriamente los números
    const seleccionadosAleatorios = [];
    for (let i = 0; i < cantidad; i++) {
      const randomIndex = Math.floor(Math.random() * disponibles.length);
      seleccionadosAleatorios.push(disponibles[randomIndex]);
      disponibles.splice(randomIndex, 1); // Eliminar el número seleccionado de disponibles
    }

    // Actualizar los seleccionados con los nuevos números aleatorios
    setSeleccionados((prevSeleccionados) => [...prevSeleccionados, ...seleccionadosAleatorios]);
  };

  const toggleNumero = (numero) => {
    if(timecero){
      reset ? Swal.fire('La seleccion de numero se reiniciara en unos minutos')
      :Swal.fire('La selección de números está bloqueada faltando menos de 5 minutos para iniciar el sorteo.')
      return
    }
    const isSelected = seleccionados.includes(numero);
    if (!isSelected) {
      setSeleccionados([...seleccionados, numero]);
    } else {
      setSeleccionados(seleccionados.filter((num) => num !== numero));
    }
  };

  const confirmarPago = () => {
    if (seleccionados.length === 0) {
        Swal.fire('Por favor, seleccione al menos un número.');
        return;
      }

      if (pagoTotal > dataInfo.data.dataUser.saldo) {
        Swal.fire('El pago total excede su saldo actual. Por favor, reduzca los números seleccionados o recargue su cuenta.');
      } else {
        Swal.fire({
          title: 'Confirmar Pago',
          text: `El monto de ${pagoTotal.toLocaleString('es-ES')} será descontado de su saldo. ¿Desea continuar?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, continuar',
          cancelButtonText: 'No, cancelar'
        }).then((result) => {
          if (result.isConfirmed) {
            console.log('confirmo pago')
            dataInfo.socket.emit('confirmarPago', {
              id: dataInfo.data.sorteo.id,
              seleccionados: seleccionados,
              uid: dataInfo.data.dataUser.uid
            });
            dataInfo.socket.on('responsConfirmarPago',(response)=>{
              Swal.fire(`${response.message}, su nuevo saldo es de: $${response.newSaldo}`)
              setSeleccionados([])
            })
          }
        });
      }
  };
  const pagoTotal = useMemo(() => seleccionados.length * dataInfo.data.sorteo.valor, [seleccionados]);
  // Definir los números ganadores de la ruleta
  
  const delays = [10000, 20000, 30000, 40000]; // Diferentes retrasos para cada rueda
  return (
    <div className="sorteo-container">
      <h1 className="titulo-blanco">Sorteo MEGALOTO Express</h1>
      <h2 className="titulo-blanco">Premio actual: ${totalPremio}</h2>
      <p className="descripcion titulo-blanco">
        A continuación, selecciona los números disponibles para el sorteo Express
        con un acumulado de <strong>${totalPremio}</strong>. Cada número tiene un valor
        de <strong>${dataInfo.data.sorteo.valor.toLocaleString('es-ES')}</strong>.
        Actualmente, tienes un saldo de <strong>${dataInfo.data.dataUser.saldo.toLocaleString('es-ES')}</strong>.
        Haz clic en los números que deseas seleccionar o selecciona números aleatorios.
      </p>
      {!timecero
        ? <div className="aleatorio-container">
          <label htmlFor="cantidadAleatoria">Seleccionar números aleatorios: </label>
          <input
            className="input"
            type="number"
            id="cantidadAleatoria"
            min="1"
            max={numeros.filter(n => Object.values(n)[0] === '').length} // Establecer el max según los disponibles
            value={cantidadAleatoria}
            onChange={(e) => setCantidadAleatoria(Number(e.target.value))}
          />
          <button className="seleccionar-aleatorios" onClick={() => seleccionarNumerosAleatorios(cantidadAleatoria)}>
            Seleccionar Aleatoriamente
          </button>
        </div>

        :<div className="aleatorio-container">
          <label htmlFor='cantidadAleatoria'>Ruleta de Numeros</label>
          <div className="ruleta-container">
            {winningNumbers.map((num, index) => (
              <RuletaNumero 
                key={index} 
                targetNumber={num} 
                delay={delays[index]} 
                start={start} 
                length={winningNumbers.length} 
                index={index} 
                finish={setFinish}
                />
            ))}
          </div>
        </div>
      }
      

      <div className="numeros-container">
        {numeros.map((n) => {
          const numeroKey = Object.keys(n)[0];
          const comprador = n[numeroKey];
          return (
            <Numero
              key={numeroKey}
              numero={numeroKey}
              comprador={comprador}
              toggleNumero={toggleNumero}
              seleccionado={seleccionados.includes(numeroKey)}
              dataInfo={dataInfo}
            />
          );
        })}
      </div>

      <div className="seleccionados">
        <h2 className="titulo-blanco">{seleccionados.length} número(s) seleccionado(s). Pago total: <span>${pagoTotal.toLocaleString('es-ES')}</span></h2>
        {seleccionados.length > 0 ? (
          <ul>
            {seleccionados.map((num) => (
              <li
                key={num}
                className="seleccionado-numero"
                onClick={() => toggleNumero(num)}
              >
                {num}
              </li>
            ))}
          </ul>
        ) : (
          <p className="titulo-blanco">No hay números seleccionados.</p>
        )}
      </div>
      <button className="confirmar-pago-btn" onClick={confirmarPago}>
        Confirmar Pago
      </button>
      {/* <button className='confirmar-pago-btn' onClick={()=>{setTimecero(!timecero)}}>cambio</button>
      <button className='confirmar-pago-btn' onClick={()=>{setStart(!start)}}>start</button> */}
    </div>
  );
};

const Numero = ({ numero, comprador, toggleNumero, seleccionado, dataInfo }) => {
  let mio = false;
  if (comprador) {
    if (comprador === dataInfo.data.dataUser.uid) {
      mio = true;
    }
    const posicion = dataInfo.data.dataUsers.findIndex(
      (obj) => obj.id === comprador
    );
    if(posicion!=-1){
      comprador = dataInfo.data.dataUsers[posicion].nombre;
    }
  }

  return (
    <div
      className={`numero ${comprador ? 'ocupado' : 'disponible'} ${seleccionado ? 'seleccionado' : ''} ${mio ? 'mio' : ''}`}
      onClick={() => !comprador && toggleNumero(numero)}
    >
      <span>{numero}</span>
      {comprador && (
        <div className="tooltip">Comprado por: {comprador}</div>
      )}
    </div>
  );
};

export default SorteoExpress;
